// webp-hero chargé via CDN dans le layout
// Initialisation du polyfill WebP pour les vieux navigateurs
if (typeof webpHero !== 'undefined') {
  const webpMachine = new webpHero.WebpMachine()
  webpMachine.polyfillDocument()
}